// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.5
//   protoc               v4.23.4
// source: peer/peer_group.proto

/* eslint-disable */

export const protobufPackage = "peer";

export enum PeerGroup {
  PEER_GROUP_UNSPECIFIED = 0,
  PEER_GROUP_MODERATOR = 1,
  PEER_GROUP_USER = 2,
  UNRECOGNIZED = -1,
}

export function peerGroupFromJSON(object: any): PeerGroup {
  switch (object) {
    case 0:
    case "PEER_GROUP_UNSPECIFIED":
      return PeerGroup.PEER_GROUP_UNSPECIFIED;
    case 1:
    case "PEER_GROUP_MODERATOR":
      return PeerGroup.PEER_GROUP_MODERATOR;
    case 2:
    case "PEER_GROUP_USER":
      return PeerGroup.PEER_GROUP_USER;
    case -1:
    case "UNRECOGNIZED":
    default:
      return PeerGroup.UNRECOGNIZED;
  }
}

export function peerGroupToJSON(object: PeerGroup): string {
  switch (object) {
    case PeerGroup.PEER_GROUP_UNSPECIFIED:
      return "PEER_GROUP_UNSPECIFIED";
    case PeerGroup.PEER_GROUP_MODERATOR:
      return "PEER_GROUP_MODERATOR";
    case PeerGroup.PEER_GROUP_USER:
      return "PEER_GROUP_USER";
    case PeerGroup.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
